import Vue from 'vue'
import Main from './main.vue'

let PurchaseConstructor = Vue.extend(Main)
const Purchase = (options, props) => {
  options = options || {}
  let data = Object.assign({}, options, {
    afterClose: () => {
      if (typeof options?.afterClose === 'function') {
        options.afterClose()
      }
      // vm.$destroy()
    }
  })
  let instance = new PurchaseConstructor({
    ...props,
    el: document.createElement('div'),
    data: data
  })
  instance.$mount()
  document.body.appendChild(instance.$el)
  instance.visible = true
  return instance
}

export default Purchase
